module.exports = __webpack_public_path__ + "img/dzp_bg.5dfeb75d.png";